import _ from 'lodash';
import moment from 'moment';

import TipoComprobante from '../../support/enum/TipoComprobante';

class ComprobanteBaseRequestInputTransformer {
  getName() {
    return 'comprobante';
  }

  make(input) {
    const { Emisor, Receptor, InformacionGlobal, Conceptos, Complemento, Metadata, fallback, ...rest } = input;
    const comprobante = TipoComprobante.make(rest.TipoDeComprobante);

    const _receptor = {
      Id: Receptor.id,
      Rfc: Receptor.rfc,
      ResidenciaFiscal: Receptor.residencia_fiscal || undefined,
      NumRegIdTrib: Receptor.num_reg_id_trib || undefined,
      Nombre: Receptor.razon_social,
      UsoCFDI: Receptor.uso_cfdi,
      Email: Receptor.email || undefined,
      CP: Receptor.cp || undefined,
      Regimen: Receptor.regimen || undefined,
    };

    let _informacionGlobal = {
      Periodicidad: InformacionGlobal?.periodicidad,
      Meses: InformacionGlobal?.meses,
      Año: InformacionGlobal?.año,
    };

    if (['XAXX010101000', 'XEXX010101000'].indexOf(Receptor.rfc) !== -1) {
      _receptor.CP = Emisor.cp;
      _receptor.Regimen = '616';
      _receptor.UsoCFDI = 'S01';
    }

    if ('XAXX010101000' !== Receptor.rfc || 'PUBLICO EN GENERAL' !== Receptor.razon_social) {
      _informacionGlobal = undefined;
    }

    const _conceptos = Conceptos?.Concepto || [];

    const _additional = Metadata?.Adicional;

    let body = {
      Version: !!_receptor.CP && !!_receptor.Regimen ? '4.0' : '3.3',
      ...rest,
      Metadata: {
        as: 'ui',
        auto_idx: true,
        Pipes: !!fallback ? ['fallback'] : undefined,
        Adicional: !!_additional ? _additional : undefined,
        Decimales: Metadata?.Decimales,
        SectorPrimario: Metadata?.SectorPrimario ?? undefined,
        id_sucursal: !!Emisor?.sucursal?.id ? Emisor?.sucursal?.id : null,
        pdf_sucursal: !!Emisor?.sucursal?.codigo_postal ? Metadata?.pdf_sucursal ?? false : false,
      },
      Clasificacion: 2,
      TipoDeComprobante: comprobante.getValue(),
      Fecha: moment(rest.Fecha || rest.FechaTemp).format('YYYY-MM-DD HH:mm:ss'),
      FechaTemp: undefined,
      CfdiFecha: !!rest.CfdiFecha ? moment(rest.CfdiFecha).format('YYYY-MM-DD HH:mm:ss') : undefined,
      Emisor: {
        Id: '' + Emisor.id,
        ...(Emisor?.sucursal?.codigo_postal ? { CP: '' + Emisor.sucursal.codigo_postal } : {}),
      },
      Receptor: {
        ..._receptor,
      },
      InformacionGlobal: {
        ..._informacionGlobal,
      },
      Conceptos: {
        Concepto: _conceptos.map((item) => {
          item = { ...item };

          delete item.id;
          delete item.Unidad;

          item.ClaveProdServ = item.ClaveProdServ || '01010101';

          if (item.ObjetoImp === '01') {
            delete item.Impuestos;
          }

          return item;
        }),
      },
      Complemento: Complemento,
    };

    delete body.Observaciones;
    delete body.Decimales;

    body = this._clearBody(body);

    return body;
  }

  _clearBody(body) {
    return _.pickBy(
      body,
      _.identity((item) => item !== '' && item !== undefined && item !== null)
    );
  }
}

export default ComprobanteBaseRequestInputTransformer;
